import { render, staticRenderFns } from "./ParadiseFeed.vue?vue&type=template&id=2becf13a"
import script from "./ParadiseFeed.vue?vue&type=script&lang=js"
export * from "./ParadiseFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports